// GPT-Live で使うモデル・backend・声 (spec 2026-09-14 L6)。
//
// **ファイルを分けている理由は realtimeModel.ts と同じ** — functions/api/live/session.ts が
// import するので tsconfig.functions.json (DOM の型が無いプロジェクト) からも型検査される。
// window を触る engine.ts には置けない。
//
// **非秘密の設定はコード定数で持つ** (dashboard の env var に置かない方針)。セッションを作る
// session.ts と、画面が session.started に載せる値の両方がここを読む (二重に書くと、
// ログ上のモデルと実際に喋ったモデルが食い違っても気づけない)。
import { REALTIME_VOICE } from "./realtimeModel";

export const LIVE_MODEL = "gpt-live-1";

/**
 * 記録を担う backend (Responses delegation)。spike で測ったもの
 * (docs/measurements/2026-09-13-gpt-live-1-spike.md)。公式は Terra から始めることを
 * 勧めているが測っていない — 替えるなら同じ評価セットで測ってから。
 */
export const LIVE_BACKEND_MODEL = "gpt-5.6-luna";

/**
 * **2.1 と同じ名前の声にする** (spec L6)。2.1 の声を選び直したらこちらも追随する。
 * **ただし同じ名前でも同じ声には聞こえない** — モデルが別なので、live の marin は 2.1 の marin より
 * 約 1.8 半音高く、母音の響きも違う (docs/measurements/2026-09-14-gpt-live-voice-compare.md)。
 * 揃える案 (live の 22 種から 2.1 に近い声を選ぶ) は採らず、据え置いた (ユーザー判断、2026-09-14)。
 * live だけが持つ新しい 12 種から選ぶときは、この行を切り離す。
 */
export const LIVE_VOICE = REALTIME_VOICE;
